import React from 'react';
import { MicroCTA } from './shared/MicroCTA';
export function Hero() {
  return <section className="pt-6 pb-10" data-id="element-321">
      <div className="mb-4" data-id="element-322">
        <span className="text-xs text-gray-500 font-sans" data-id="element-323">
          Sponsrat redaktionellt innehåll
        </span>
      </div>
      <div className="mb-6" data-id="element-324">
        <p className="text-[#2e7d32] text-sm font-medium mb-2" data-id="element-325">
          Forskare närmar sig svaret på "mental dimma" efter 50
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-326">
          Upptäckten som fick mig att se klart igen
        </h1>
        <p className="text-lg sm:text-xl mb-4" data-id="element-327">
          När vardaglig glömska började{' '}
          <span className="italic" data-id="element-328">styra mitt liv</span> letade jag efter något
          som faktiskt hjälper – utan överdrivna löften eller snabba genvägar.
        </p>
        <div className="text-sm text-gray-600 mb-6" data-id="element-329">
          <p data-id="element-330">
            Av Anna Lindström • Publicerad: 11 september 2025 • Läs-tid: 15–20
            min
          </p>
        </div>
      </div>
      <div className="relative mb-8" data-id="element-331">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/c7mKREyvt9UE2bcxdEACPx/heroimage.webp" alt="Äldre kvinna med vitt hår i en vit kofta samtalar med vänner i köket" className="w-full h-auto rounded-lg shadow-md object-cover" style={{
        height: '400px'
      }} width="1200" height="400" data-id="element-332" />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 rounded-b-lg" data-id="element-333">
          <p className="text-white text-sm md:text-base italic" data-id="element-334">
            "Det värsta var inte glömskan i sig – utan känslan av att långsamt
            förlora kontrollen över mitt eget sinne..."
          </p>
        </div>
      </div>
      <MicroCTA text="Hoppa till erbjudandet" href="#offer" className="text-right" data-id="element-335" />
    </section>;
}